<script setup>
import { useExperiencePoints } from '/app/composables/brain';

const props = defineProps({
    fqdn: {
        type: String,
        required: true,
    },
});

const { points } = useExperiencePoints(props.fqdn);
</script>

<template>
    <slot :points="points"></slot>
</template>